import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeaders, axiosInstance, logError } from "../../utils/helper";

const initialState = {
  data: [],
  loading: false,
};

export const getBannerList = createAsyncThunk(
  "banner/getBannerList",
  async (params) => {
    const res = await axiosInstance.get("banner/listBanner", { params, ...authHeaders() });
    const data = await res.data;
    return data;
  }
);

const banner = createSlice({
  name: "banner",
  initialState,
  reducers: {
    setBanner: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearBanner: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBannerList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBannerList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.result;
      })
      .addCase(getBannerList.rejected, (state, action) => {
        state.loading = false;

        // logError(new Error(action.error?.message), {
        //   feature: "getBannerList",
        //   actionType: action.type,
        // });
      });
  },
});

// Export actions and reducer
export const { setBanner, clearBanner } = banner.actions;
export default banner.reducer;
